import { Button, UIText1, UiKitRoot } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { TWithModalProps } from 'shared/common/types/components';
import { EModalSource } from 'shared/common/types/modal';
import { B2B_CPN_NONE_OPERATIONAL_FUNNEL_ON_CPD_LANDING } from '../../../common/constants/experiments';
import { Experiment } from '@cian/experiments/ab';

interface IHelpYouSellProps extends TWithModalProps {
  onConsultationClick?: () => void;
}

export const getUTP = (onOpenQualityCriteriaModal: () => void) => [
  {
    title: (
      <span>
        Выбрали лучших агентов по&nbsp;своим&nbsp;
        <span
          className={style['clickable-text']}
          onClick={onOpenQualityCriteriaModal}
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              onOpenQualityCriteriaModal();
            }
          }}
        >
          критериям качества
        </span>
      </span>
    ),
    imageClass: 'photos',
  },
  {
    title: 'Ваш объект увидит максимум покупателей',
    imageClass: 'duck',
  },
  {
    title: <span>Без предоплат и скрытых комиссий</span>,
    imageClass: 'umbrella',
  },
];

const CardMobile = ({ text, imageClass }: { text: React.ReactNode; imageClass: string }) => {
  return (
    <div className={style['card-mobile']}>
      <div className={clsx(style['item-image'], style[imageClass])} />
      <UIText1 color="text-inverted-default">{text}</UIText1>
    </div>
  );
};

const CardDesktop = ({ text, imageClass }: { text: React.ReactNode; imageClass: string }) => {
  return (
    <div className={style['card-desktop']}>
      <div className={clsx(style['item-image'], style[`${imageClass}-desktop`])} />
      <UIText1 color="text-inverted-default" fontWeight="700">
        {text}
      </UIText1>
    </div>
  );
};

export const HelpYouSell: React.FC<IHelpYouSellProps> = ({ device, onOpenModal, onConsultationClick }) => {
  const handleOpenQualityCriteriaModal = () => {
    onOpenModal(EModalSource.QualityCriteria);
  };

  const UTP = getUTP(handleOpenQualityCriteriaModal);

  return (
    <div className={style['light-theme-wrapper']}>
      <UiKitRoot theme="light">
        <div className={clsx(style['container'], style[device])} data-name="HelpYouSell">
          <div className={style['wrapper']}>
            <div className={style['top']}>
              <div className={style['name']}>Сделка на Циане</div>
              <div className={style['title']}>Продайте недвижимость выгодно и&nbsp;спокойно</div>
              <div className={style['btn-container']} data-name="HelpYouSellButtonsDesktop">
                <Button theme="fill_white_primary" size="L" onClick={() => onOpenModal(EModalSource.Consultation)}>
                  Получить консультацию
                </Button>

                <Experiment name={B2B_CPN_NONE_OPERATIONAL_FUNNEL_ON_CPD_LANDING} group="B">
                  <UiKitRoot deviceType="phone" theme="colored">
                    <Button theme="fill_secondary" size="L" onClick={onConsultationClick}>
                      Подобрать агента
                    </Button>
                  </UiKitRoot>
                </Experiment>
              </div>
              <div className={style['cards-desktop']}>
                {UTP.map(i => (
                  <CardDesktop imageClass={i.imageClass} text={i.title} key={i.imageClass} />
                ))}
              </div>
            </div>
            <div className={style['bottom']}>
              <div className={style['cards-mobile']}>
                {UTP.map(i => (
                  <CardMobile imageClass={i.imageClass} text={i.title} key={i.imageClass} />
                ))}
              </div>

              <div className={style['btn-container-bottom']} data-name="HelpYouSellButtonsMobile">
                <Button
                  theme="fill_white_primary"
                  size="L"
                  onClick={() => onOpenModal(EModalSource.Consultation)}
                  fullWidth
                >
                  Получить консультацию
                </Button>

                <Experiment name={B2B_CPN_NONE_OPERATIONAL_FUNNEL_ON_CPD_LANDING} group="B">
                  <Button theme="fill_primary" size="L" onClick={onConsultationClick}>
                    Подобрать агента
                  </Button>
                </Experiment>
              </div>
            </div>
          </div>
        </div>
      </UiKitRoot>
    </div>
  );
};
